import React from 'react'
import Helmet from 'react-helmet'
import { graphql } from 'gatsby'
import * as styles from './index.module.scss'

import Layout from '../components/layout'
import FeaturedPost from '../components/FeaturedPost'
import PostPreview from '../components/PostPreview'

import { CONFIG } from '../config'

const formatPost = ({
  node: {
    slug,
    title,
    publishDate,
    backgroundColour: { hex },
    heroImage: {
      file: { url: src },
    },
  },
}) => ({
  slug,
  title,
  publishDate,
  backgroundColour: hex,
  imageSrc: src,
})

const fetchPosts = ({
  data: {
    allContentfulBlogPost: { edges },
  },
}) => {
  return edges.map(formatPost)
}

class RootIndex extends React.Component {
  render() {
    const [featuredPost, ...posts] = fetchPosts(this.props)
    const numOrphans = posts.length % 3
    const childEndIndex = posts.length - numOrphans
    const orphanStartIndex = childEndIndex

    return (
      <Layout location={this.props.location}>
        <div style={{ background: '#fff', width: '100%' }}>
          <Helmet>
            <title>SMARTY blog</title>
            <meta name="title" content="SMARTY blog" />
            <meta
              name="description"
              content="Find out what we've been doing, learning and sharing at SMARTY recently"
            />
            <link
              rel="stylesheet"
              href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
            />
            <link
              rel="shortcut icon"
              sizes="16x16 32x32"
              type="image/png"
              href={`${CONFIG.MARKETING_URL}favicon.png`}
            ></link>
            <link
              rel="apple-touch-icon"
              href={`${CONFIG.MARKETING_URL}apple-touch-icon.png`}
            />
            <link rel="canonical" href={`${CONFIG.BLOG_URL}`} />
            <link
              rel="sitemap"
              type="application/xml"
              href={`${CONFIG.MARKETING_URL}sitemap.xml`}
            />
          </Helmet>
          <header className={styles.Header} role="main">
            <div className={styles.HeaderInner}>
              <h1>SMARTY Blog</h1>
              <p>
                Here’s what we’ve been doing, learning and sharing at SMARTY
                recently.
              </p>
            </div>
          </header>
          <div className={styles.Content}>
            <div
              className={styles.FeaturedPost}
              role="complementary"
              aria-label="Featured Post"
            >
              <h2>Featured</h2>
              <div
                className={styles.PostHover}
                style={{ background: `${featuredPost.backgroundColour}` }}
              >
                <FeaturedPost {...featuredPost} />
              </div>
            </div>
            <div
              className={styles.Posts}
              role="complementary"
              aria-label="Other Posts"
            >
              <h2>More Content</h2>
              <div className={styles.PostChildren}>
                {posts.slice(0, childEndIndex).map((post, i) => (
                  <div
                    key={i}
                    className={`${styles.PostHover} post`}
                    style={{ background: `${post.backgroundColour}` }}
                    data-testid={`post-${i}`}
                  >
                    <PostPreview key={post.slug} {...post} />
                  </div>
                ))}
              </div>
              <div className={styles.PostOrphans}>
                {posts.slice(orphanStartIndex).map((post, i) => (
                  <div
                    key={i}
                    className={`${styles.PostHover} post`}
                    style={{ background: `${post.backgroundColour}` }}
                    data-testid={`post-orphan-${i}`}
                  >
                    <PostPreview key={post.slug} {...post} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </Layout>
    )
  }
}

export default RootIndex

export const pageQuery = graphql`
  query HomeQuery {
    allContentfulBlogPost(sort: { publishDate: DESC }) {
      edges {
        node {
          title
          slug
          publishDate(formatString: "MMMM Do, YYYY")
          heroImage {
            title
            description
            file {
              url
            }
          }
          backgroundColour {
            hex
          }
        }
      }
    }
    allContentfulPerson(filter: { id: { eq: "c15jwOBqpxqSAOy2eOO4S0m" } }) {
      edges {
        node {
          name
          shortBio {
            shortBio
          }
          title
        }
      }
    }
  }
`
